/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Leave_QInputs */

const en_platform_faq_leave_q = /** @type {(inputs: Platform_Faq_Leave_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I want to leave?`)
};

const pl_platform_faq_leave_q = /** @type {(inputs: Platform_Faq_Leave_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A jeśli będę chciał odejść?`)
};

/**
* | output |
* | --- |
* | "What if I want to leave?" |
*
* @param {Platform_Faq_Leave_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_leave_q = /** @type {((inputs?: Platform_Faq_Leave_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Leave_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_leave_q(inputs)
	return en_platform_faq_leave_q(inputs)
});